import {
  HeroContentContainer,
  HeroTitle,
  HeroText,
  HeroImage,
} from "./HeroContent.styled";
import { Trans, useTranslation } from "react-i18next";
import { ReactNode } from "react";
import { ButtonLink } from "../../ButtonLink/ButtonLink";
import Image from "../../../assets/images/hero-img-p-800.png";

export const HeroContent = (props: HeroContentProps) => {
  const { t } = useTranslation();

  return (
    <HeroContentContainer>
      <HeroTitle>
        <Trans i18nKey={"sectionHero.title"} />
      </HeroTitle>
      <HeroText>
        <Trans i18nKey={"sectionHero.text"} />
      </HeroText>
      <ButtonLink href="#contact" largeButton={true}>
        {<Trans i18nKey={"common.contactUs"} />}
      </ButtonLink>
      <HeroImage src={Image} />
    </HeroContentContainer>
  );
};

export interface HeroContentProps {
  //$backgroundColor: string;
}
export interface HeroImageProps {
  //$backgroundColor: string;
  id?: string;
  children: ReactNode;
  title?: string;
  showSectionDecoration?: boolean;
}
